import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { createAuthSlice, type AuthSlice } from "./slices/authSlice";
import { createTaskSlice, type TaskSlice } from "./slices/taskSlice";
import { createTagSlice, type TagSlice } from "./slices/tagSlice";
import { createRecurringSlice, type RecurringSlice } from "./slices/recurringSlice";
import { createDependencySlice, type DependencySlice } from "./slices/dependencySlice";

export interface IStoreState extends AuthSlice, TaskSlice, TagSlice, RecurringSlice, DependencySlice {
  loading: {
    auth: boolean;
    tasks: boolean;
    recurring: boolean;
    tags: boolean;
    sharedTasks: boolean;
  };
}

export const useStore = create<IStoreState>()(
  devtools(
    (...a) => ({
      loading: {
        auth: true,
        tasks: false,
        recurring: false,
        tags: false,
        sharedTasks: false,
      },
      ...createAuthSlice(...a),
      ...createTaskSlice(...a),
      ...createTagSlice(...a),
      ...createRecurringSlice(...a),
      ...createDependencySlice(...a),
    }),
    { name: "task-manager-store" }
  )
);
